// extracted by mini-css-extract-plugin
export default {"icon":"AppScrollButton_icon_H9dR5","icon_logo":"AppScrollButton_icon_logo_qgwO_"};